import React, { useState, useEffect, useCallback } from 'react';
import { Quote, ChevronLeft, ChevronRight } from 'lucide-react';
import { testimonials } from '../mock';

const Testimonials = () => {
  const [idx, setIdx] = useState(0);
  const next = useCallback(() => setIdx((i) => (i + 1) % testimonials.length), []);
  const prev = useCallback(() => setIdx((i) => (i - 1 + testimonials.length) % testimonials.length), []);

  useEffect(() => {
    const timer = setInterval(next, 7000);
    return () => clearInterval(timer);
  }, [next]);

  const t = testimonials[idx];

  return (
    <section id="testimonials" className="py-28 bg-[#faf7f0] relative overflow-hidden">
      <div className="max-w-5xl mx-auto px-6 lg:px-10 text-center">
        <div className="ornament justify-center inline-flex mb-4">
          <span className="section-eyebrow">Whispers from Clients</span>
        </div>
        <h2 className="font-display text-4xl md:text-5xl text-[#1a1714]">
          What our <span className="italic font-cormorant gold-text">souls</span> say
        </h2>

        <div className="relative mt-16 min-h-[260px]">
          <Quote className="absolute -top-6 left-1/2 -translate-x-1/2 text-[#c9a961]/30" size={80} />
          <div key={t.id} className="animate-[fadeIn_0.6s_ease]">
            <p className="font-cormorant italic text-2xl md:text-3xl text-[#2b2521] leading-relaxed max-w-3xl mx-auto">
              “{t.quote}”
            </p>
            <div className="shimmer-divider w-24 mx-auto my-7" />
            <div className="font-display text-lg text-[#1a1714]">{t.name}</div>
            <div className="text-[11px] tracking-[0.3em] uppercase text-[#a8842c] mt-1">{t.role}</div>
          </div>
        </div>

        <div className="flex items-center justify-center gap-6 mt-12">
          <button onClick={prev} className="w-11 h-11 border border-[#c9a961]/50 flex items-center justify-center text-[#a8842c] hover:bg-[#c9a961]/15 transition-all">
            <ChevronLeft size={18} />
          </button>
          <div className="flex gap-2">
            {testimonials.map((it, i) => (
              <button
                key={it.id}
                onClick={() => setIdx(i)}
                className={`h-1.5 transition-all ${i === idx ? 'w-8 bg-[#a8842c]' : 'w-3 bg-[#c9a961]/40'}`}
              />
            ))}
          </div>
          <button onClick={next} className="w-11 h-11 border border-[#c9a961]/50 flex items-center justify-center text-[#a8842c] hover:bg-[#c9a961]/15 transition-all">
            <ChevronRight size={18} />
          </button>
        </div>
      </div>
      <style>{`@keyframes fadeIn { from { opacity: 0; transform: translateY(8px);} to { opacity: 1; transform: translateY(0);} }`}</style>
    </section>
  );
};

export default Testimonials;
